import { NextSeo } from 'next-seo';
import FormValidation from '@/components/FormValidation';
import { GetPathName } from '@/lib/helpers';

const Page = () => {
  return (
    <>
      <NextSeo
        title="Formularvalidierung"
        description="Basiselemente - Plausibilitätsprüfungen der Formulare realisiert mit Bootstrap 5 und Vanilla-Javascript."
        canonical={`${process.env.NEXT_PUBLIC_BASE_URL}${GetPathName()}`}
      />

      <FormValidation />
    </>
  );
};

export default Page;
